import MasteryRing from './MasteryRing';
import './AssignedPathCard.css';

const SOURCE_LABELS = {
  ingestible: 'DOC',
  axiom: 'RAG',
  ckb: 'CODE',
  manual: 'MANUAL',
};

function statusInfo(coverage, competency) {
  if (competency >= 0.8) return { key: 'ready', label: 'Certification Ready' };
  if (coverage > 0)      return { key: 'progress', label: 'In Progress' };
  return                        { key: 'new', label: 'Not Started' };
}

function nudgeText(dueCount, status) {
  if (dueCount > 0) return { text: `${dueCount} card${dueCount !== 1 ? 's' : ''} due — review now`, urgent: true };
  if (status === 'ready')    return { text: 'Mastery achieved', urgent: false };
  if (status === 'progress') return { text: 'On track · nothing due today', urgent: false };
  return                            { text: 'Ready to begin', urgent: false };
}

export default function AssignedPathCard({ path, onDeepDive, onRecall, onSimulate }) {
  const totalCards   = Number(path.total_cards)    || 0;
  const learnedCards = Number(path.learned_cards)  || 0;
  const dueCount     = Number(path.due_count)      || 0;
  const moduleCount  = Number(path.module_count)   || 0;

  const coverage    = totalCards > 0 ? learnedCards / totalCards : 0;
  const competency  = Math.min(1, (Number(path.competency_score) || 0) / 100);
  const { key: statusKey, label: statusLabel } = statusInfo(coverage, competency);
  const nudge = nudgeText(dueCount, statusKey);

  const sourceLabel = SOURCE_LABELS[path.source_type] || null;

  return (
    <div className="assigned-path-card">
      {/* Header row */}
      <div className="apc-header">
        <div className="apc-icon" style={{ color: path.color || 'var(--accent)' }}>
          {path.icon || '📚'}
        </div>
        <div className="apc-title-block">
          <div className="apc-name">{path.name}</div>
          <div className="apc-meta-row">
            <span className={`apc-status-badge status-${statusKey}`}>{statusLabel}</span>
            {sourceLabel && <span className="apc-source-badge">{sourceLabel}</span>}
            {moduleCount > 0 && (
              <span className="apc-module-count">{moduleCount} module{moduleCount !== 1 ? 's' : ''}</span>
            )}
          </div>
        </div>
        <MasteryRing coverage={coverage} competency={competency} size={52} />
      </div>

      {/* Progress bars */}
      <div className="apc-progress-section">
        <div className="apc-progress-item">
          <span className="apc-progress-label">Coverage</span>
          <div className="apc-progress-track">
            <div
              className="apc-progress-fill coverage-fill"
              style={{ width: `${Math.round(coverage * 100)}%` }}
            />
          </div>
          <span className="apc-progress-pct">{Math.round(coverage * 100)}%</span>
        </div>
        <div className="apc-progress-item">
          <span className="apc-progress-label">Competency</span>
          <div className="apc-progress-track">
            <div
              className="apc-progress-fill competency-fill"
              style={{
                width: `${Math.round(competency * 100)}%`,
                background: competency >= 0.8 ? '#00ff88' : competency >= 0.6 ? '#f59e0b' : '#ff6b35',
              }}
            />
          </div>
          <span className="apc-progress-pct">{Math.round(competency * 100)}%</span>
        </div>
      </div>

      {/* Nudge */}
      <div className={`apc-nudge${nudge.urgent ? ' urgent' : ''}`}>
        {nudge.urgent ? '⚡ ' : ''}{nudge.text}
      </div>

      {/* Action buttons */}
      <div className="apc-actions">
        <button className="apc-btn apc-btn-primary" onClick={onDeepDive}>
          Deep Dive
        </button>
        <button className="apc-btn apc-btn-secondary" onClick={onRecall}>
          Recall
        </button>
        <button
          className="apc-btn apc-btn-ghost"
          onClick={onSimulate}
          disabled
          title="Coming soon"
        >
          Simulate
        </button>
      </div>
    </div>
  );
}
